import React from 'react'
import style from '../card.module.css'

function Test5() {
  return (
    <div className={style.prepration_card}>
     <h3>English Special Free Test</h3>
        <button>Free</button> 
        <div>
        <p>Test 3 . Mar 12, 11:00 AM</p>      
        </div>        
    </div>
  )
}

export default Test5